import './style.css'
import { default as Standard } from './Standard'
import { default as WithApi } from './WithApi'

export default {
  Standard,
  WithApi,
}
